import { PrintMenu } from '../print-menu';

export abstract class ReportMenu extends PrintMenu {
  getMenuClass(): string {
    return `print-menu report-menu ${this.getThemeClass()}`;
  }
}
